import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import classNames from 'classnames';

export const MuiTitle = ({
  isSize = null,
  hasTextColor = null,
  tag = null,
  children = null,
  className = '',
  ...rest
}) => {
  // Use Bloomer classNames for direct compatibility
  const titleClass = isSize ? `title is-${isSize}` : 'title';
  const colorClass = hasTextColor ? `has-text-${hasTextColor}` : '';
  const combinedClassName = classNames(titleClass, colorClass, className);

  return (
    <Typography
      className={combinedClassName}
      sx={{
        fontWeight: '450 !important',
      }}
      {...rest}
    >
      {children}
    </Typography>
  );
};

// eslint-disable-next-line react/require-default-props
MuiTitle.propTypes = {
  isSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  hasTextColor: PropTypes.string,
  tag: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default MuiTitle;
